import React from "react";
import { Link } from "react-router-dom";
import LegalPageShell from "./LegalPageShell";
import { LEGAL_PRIVACY_EMAIL, LEGAL_SITE_URL, LEGAL_SUPPORT_EMAIL } from "./legalContent";

export default function RefundPolicy() {
  return (
    <LegalPageShell title="Refund & Cancellation Policy">
      <h2>1. Overview</h2>
      <p>
        This Refund &amp; Cancellation Policy applies to subscription fees paid to{" "}
        <strong>Beentara</strong> for access to our SaaS platform at{" "}
        <a href={LEGAL_SITE_URL} target="_blank" rel="noopener noreferrer">
          beentara.com
        </a>{" "}
        and the Beentara admin panel. Payments are processed securely through our payment partner,
        Razorpay.
      </p>
      <p>
        By subscribing to a paid plan, you agree to this policy in addition to our{" "}
        <Link to="/terms-conditions">Terms &amp; Conditions</Link>.
      </p>

      <h2>2. Free trial</h2>
      <p>
        Eligible plans include a free trial period (typically 15 days) as shown on our pricing page.
        During the trial you may cancel at any time before it expires without being charged.
      </p>

      <h2>3. Subscription billing</h2>
      <p>
        Beentara offers monthly and yearly billing cycles. All prices are displayed in Indian Rupees
        (INR) and include applicable taxes unless stated otherwise at checkout.
      </p>

      <h2>4. Cancellation</h2>
      <p>You may cancel your subscription at any time through your Beentara admin account or by emailing{" "}
        <a href={`mailto:${LEGAL_SUPPORT_EMAIL}`}>{LEGAL_SUPPORT_EMAIL}</a>.
      </p>
      <p>
        Upon cancellation, your subscription remains active until the end of the current paid billing
        period. We do not provide partial refunds for unused time within an active billing period,
        except where required by law or as described below.
      </p>

      <h2>5. Refund eligibility</h2>
      <p>Subscription fees are generally non-refundable. However, we may issue a refund when:</p>
      <ul>
        <li>You were charged twice for the same billing period or charged an incorrect amount due to a technical error.</li>
        <li>You could not access the Platform for more than 72 continuous hours due to a fault attributable to Beentara.</li>
        <li>You upgrade from a free trial to a paid plan and request a refund within 7 calendar days of the first successful payment.</li>
        <li>A refund is mandated under applicable consumer protection laws in India.</li>
      </ul>

      <h2>6. How to request a refund</h2>
      <p>
        Email <a href={`mailto:${LEGAL_SUPPORT_EMAIL}`}>{LEGAL_SUPPORT_EMAIL}</a> with your business
        name, registered email, transaction date, Razorpay payment ID, and reason for the request.
        Approved refunds are processed back to the original payment method within 7–10 business days.
      </p>

      <h2>7. End-customer transactions</h2>
      <p>
        If you use Beentara to accept payments from your own customers, refunds for those transactions
        are your responsibility as the merchant.
      </p>

      <h2>8. Contact</h2>
      <ul>
        <li>Email: <a href={`mailto:${LEGAL_SUPPORT_EMAIL}`}>{LEGAL_SUPPORT_EMAIL}</a></li>
        <li>Privacy &amp; legal: <a href={`mailto:${LEGAL_PRIVACY_EMAIL}`}>{LEGAL_PRIVACY_EMAIL}</a></li>
        <li>Contact form: <Link to="/contact">beentara.com/contact</Link></li>
      </ul>
    </LegalPageShell>
  );
}
